import { gql } from "@apollo/client";

export const GET_WORKSPACES = gql`
  query contextualizador {
    base {
      workspaces {
        id
        name
      }
    }
  }
`;

export const GET_ORIGINS = gql`
  query originsQuery($scenarioId: ID!, $originFilter: OriginInput) {
    data(scenarioId: $scenarioId) {
      origins(filter: $originFilter) {
        id
        label
      }
    }
  }
`;
